import React, { useState, useEffect } from "react";
import Select from "react-select";
import "./Form.css";
import { addWalletFund } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import ConfirmationModal from "../../../components/common/ConfirmModal";

function FormWallet({ listofusers }) {
  const token = useSelector((store) => store.userReducer.token);
  const [formData, setFormData] = useState({
    userId: "",
    depositAmount: "",
    utr: "",
    remark: "",
    paymentMode: "Bank Transfer",
  });
  const [totalOptions, setTotalOptions] = useState([]);
  const [selectedMerchant, setSelectedMerchant] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isConfirmModal, setIsConfirmModal] = useState(false);

  useEffect(() => {
    const userOptions = listofusers?.map((user) => ({
      value: user.id,
      label: user?.alias || user?.id,
    }));
    setTotalOptions(userOptions);
  }, [listofusers]);

  const handleInputChange = (field, value) => {
    if (field === "userId") {
      setSelectedMerchant(value);
      setFormData((prevData) => ({
        ...prevData,
        [field]: value.value,
      }));

      return;
    }

    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const userConfirmed = await openConfirmation();
    if(!userConfirmed) return;
    setLoading(true);

    try {
      await addWalletFund(token, formData);
      toast.success("Fund uploaded successfully.");
    } catch (err) {
      toast.error("Fund could not be uploaded.");
      console.log(err.message);
    } finally {
      setLoading(false);
      setSelectedMerchant(null);
      setFormData({
        userId: "",
        depositAmount: "",
        utr: "",
        remark: "",
        paymentMode: "Bank Transfer",
      });
    }
  };

  const openConfirmation = () => {
    return new Promise((resolve) => {
      setIsConfirmModal(() => ({
        isOpen: true,
        onResolve: resolve,
      }));
    });
  };

  return (
    <div className="form-wallet-container">
      <h2 className="form-title">Wallet Upload</h2>
      <form className="wallet-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">Select Merchant</label>
          <Select
            options={totalOptions}
            value={selectedMerchant}
            onChange={(e) => handleInputChange("userId", e)}
            placeholder="Select Merchant"
            className="form-select"
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">Deposit Amount</label>
          <input
            type="number"
            placeholder="Enter deposit amount"
            className="form-input"
            value={formData.depositAmount}
            onChange={(e) => handleInputChange("depositAmount", e.target.value)}
            min="1"
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">UTR (Optional)</label>
          <input
            type="text"
            placeholder="Enter UTR"
            className="form-input"
            value={formData.utr}
            onChange={(e) => handleInputChange("utr", e.target.value)}
          />
        </div>

        <div className="form-group">
          <label className="form-label">Remarks</label>
          <input
            type="text"
            placeholder="Enter remarks"
            className="form-input"
            value={formData.remark}
            onChange={(e) => handleInputChange("remark", e.target.value)}
          />
        </div>

        <div className="form-group">
          <label className="form-label">Payment Mode</label>
          <div className="form-toggle-group">
            <label
              className={`toggle-switch ${
                formData.paymentMode === "Bank Transfer" ? "active" : ""
              }`}
            >
              <input
                type="radio"
                name="paymentMode"
                value="Bank Transfer"
                checked={formData.paymentMode === "Bank Transfer"}
                onChange={(e) =>
                  handleInputChange("paymentMode", e.target.value)
                }
              />
              Bank Transfer
            </label>
            <label
              className={`toggle-switch ${
                formData.paymentMode === "Others" ? "active" : ""
              }`}
            >
              <input
                type="radio"
                name="paymentMode"
                value="Others"
                checked={formData.paymentMode === "Others"}
                onChange={(e) =>
                  handleInputChange("paymentMode", e.target.value)
                }
              />
              Others
            </label>
          </div>
        </div>

        <div className="form-group">
          <button
            type="submit"
            className="fund-load-submit-button"
            disabled={loading}
          >
            {loading ? <div className="fund-load-loader"></div> : "Submit"}
          </button>
        </div>
      </form>

      {isConfirmModal && (
        <ConfirmationModal
          onResolve={(decision) => {
            isConfirmModal.onResolve(decision);
            setIsConfirmModal(false);
          }}
        />
      )}
    </div>
  );
}

export default FormWallet;
